import { ForwardRefExoticComponent } from 'react';

import { mockComponent } from '@hh.ru/magritte-ui-mock-component';

export const IconDynamic: ForwardRefExoticComponent<Record<string, unknown>> = mockComponent('IconDynamic', undefined, {
    withChildren: true,
});

interface IconsMockModule extends ForwardRefExoticComponent<Record<string, unknown>> {
    isIcon?: boolean;
}

export const mockIconVariants = (path: string): void => {
    const iconsModule: Record<string, unknown> = jest.requireActual(path);
    const iconsMockModule: Record<string, IconsMockModule> = {};

    Object.keys(iconsModule).forEach((key) => {
        iconsMockModule[key] = mockComponent(key, undefined, {
            withChildren: false,
        });
        iconsMockModule[key].isIcon = true;
    });

    jest.mock(path, () => {
        return {
            __esModule: true,
            ...iconsMockModule,
        };
    });
};
